import {Theme} from '@mui/material'

export const eventRowSx = (selected?: boolean) => ({
  cursor: 'pointer',
  backgroundColor: ({palette}: Theme) => (selected ? palette.action.selected : 'transparent'),
  '&:hover': {
    backgroundColor: ({palette}: Theme) =>
      selected ? palette.action.selected : palette.action.hover
  }
})
